import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import helper from '../shared/helper';

Vue.use(Vuex);

const store = new Vuex.Store(
	{
		state: {
			appConfig: {
				isLoading: false,
				snackbar: {
					text: '',
					isVisible: false,
					color: 'primary',
					timeout: 5000,
				},
			},
			user: {
				email: '',
				logo: '',
				profileImage: '',
				username: '',
			},
			token: helper.getLocalToken(),
		},
		actions,
		getters,
		mutations,
	},
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js